var React = require('react');

function BarChartUp32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31.725 3.179c-.01.051-.005.102-.024.152L29.717 8.81a.993.993 0 0 1-1.271.596.998.998 0 0 1-.593-1.277l1.197-3.305L1.403 16.855a.995.995 0 0 1-.789-1.828L28.19 3.028l-2.749-1.104a1 1 0 0 1-.553-1.296.994.994 0 0 1 1.289-.555l4.957 1.991h.001l.003.001c.028.012.047.035.073.049a.978.978 0 0 1 .247.16 1 1 0 0 1 .218.315l.004.006c.015.035.012.072.023.108.026.086.053.171.055.262.002.074-.019.143-.033.214zM1.009 20.921h3.968c.548 0 .963.439.963.989v9c0 .55-.415.968-.963.968H1.009a.992.992 0 0 1-.992-.995v-8.966c0-.55.443-.996.992-.996zm.931 8.989l2.045-.024v-6.972L1.94 22.91v7zm7.005-11.978h3.968c.548 0 .992.447.992.997v11.954c0 .55-.444.995-.992.995H8.945a.993.993 0 0 1-.992-.995V18.929c0-.55.444-.997.992-.997zm.992 11.954h1.984v-9.961H9.937v9.961zm6.944-14.941h3.968c.549 0 .992.445.992.995v14.943c0 .55-.443.995-.992.995h-3.968c-.548 0-.941-.418-.941-.968v-15c0-.55.393-.965.941-.965zm.992 14.941l2.067.024v-13l-2.067.027v12.949zm6.944-17.93h3.968c.549 0 .992.446.992.996v17.931c0 .55-.443.995-.992.995h-3.968c-.548 0-.877-.418-.877-.968v-18c0-.55.329-.954.877-.954zm.992 17.93l2.131.024v-16l-2.131.038v15.938z","key":1})]);
}

BarChartUp32px.displayName = "BarChartUp32px";

BarChartUp32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.78 31.88"};

module.exports = BarChartUp32px;

BarChartUp32px.default = BarChartUp32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/bar-chart-up-32px.svg
// module id = 1087
// module chunks = 0